<template>
    <v-container fluid>
        <wzvz_overview_hdr ref="wzvz_overview_hdr" :filter="filter" class="mb-2" @updateView="updateView" @selectAll="selectAll" @approveDeclineWzvzSelected="approveDeclineWzvzSelected" @approveDeclineRemark="approveDeclineRemark"/>
        <wzvz_overview_lst ref="wzvz_overview_lst" :view="view" :acco="acco" @updateSelection="updateSelection"/>
    </v-container>
</template>
 
<script>
    import wzvz_overview_hdr from "@/components/wzvz/wzvz_overview_hdr.vue";
    import wzvz_overview_lst from "@/components/wzvz/wzvz_overview_lst.vue";

    export default {
        components: {
            wzvz_overview_hdr,
            wzvz_overview_lst,
        },
        props: {
            filter: {
                type: String,
                required: true
            },
            acco: {
                type: String,
                required: false,
                default: ""
            }
        },    
        data() {
            return {
                view: [this.filter],
            }
        },    
        mounted() {
            this.$refs.wzvz_overview_hdr.selectView(this.filter);
        },  
        methods: { 
            updateView(newValue) {
                this.view = newValue;
                this.$refs.wzvz_overview_lst.listWzvz(newValue);
            }, 
            updateSelection(newValue) {
                this.$refs.wzvz_overview_hdr.updateSelection(newValue);
            },
            selectAll(newValue) {
                this.$refs.wzvz_overview_lst.selectAll(newValue);
            },
            approveDeclineWzvzSelected(approve) {
                this.$refs.wzvz_overview_lst.approveDeclineWzvzSelected(approve);
            },
            approveDeclineRemark() {
                this.$refs.wzvz_overview_lst.approveDeclineRemark();
            },
        }
    }
</script> 

<style scoped> 

</style>